module.exports = __webpack_public_path__ + "img/avatar6.5fa9e896.png";